<div class="eq-modal">
    <div class="eq-modal__header">
        <h3>{{ (isEdit ? 'equipment_modal_title_edit' : 'equipment_modal_title_add') | translate }}</h3>
        <button type="button" class="eq-modal__close" (click)="activeModal.dismiss()" [attr.aria-label]="'admin_action_close' | translate">&times;</button>
    </div>

    <form class="eq-modal__body" (ngSubmit)="save()">
        <div class="field-row">
            <label class="field">
                <span>{{ 'equipment_field_code' | translate }} <em>*</em></span>
                <input ngbAutofocus type="text" name="code" [(ngModel)]="code" (ngModelChange)="onCodeChange()"
                    placeholder="DP-71" autocomplete="off" [class.invalid]="codeInvalid" />
            </label>
            <label class="field">
                <span>{{ 'equipment_field_slug' | translate }} <em>*</em></span>
                <input type="text" name="slug" [(ngModel)]="slug" (input)="onSlugInput()" placeholder="dp-71"
                    autocomplete="off" [class.invalid]="slugInvalid" />
            </label>
        </div>

        @if (slugChanged) {
            <!-- The slug is the public address; old links stop resolving. -->
            <p class="warn">{{ 'equipment_modal_slug_warning' | translate: { newSlug: slug, oldSlug: equipment?.slug } }}</p>
        }

        <label class="field">
            <span>{{ 'field_name' | translate }}</span>
            <input type="text" name="name" [(ngModel)]="name" placeholder="DIN Rail Power Supply"
                autocomplete="off" />
        </label>

        <label class="field">
            <span>{{ 'equipment_modal_features' | translate }}</span>
            <textarea name="features" [(ngModel)]="features" rows="3"
                [placeholder]="'equipment_modal_features_placeholder' | translate"></textarea>
        </label>

        <div class="field">
            <span>{{ 'field_photo' | translate }}</span>
            <!-- Click or drop. The file is previewed locally and uploaded to S3
                 by the server when the form is saved. -->
            <div class="dropzone" [class.dragging]="dragging" [class.has-image]="!!previewUrl"
                (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                (click)="fileInput.click()">
                @if (previewUrl) {
                    <img [src]="previewUrl" alt="" class="preview" />
                    <div class="dropzone__meta">
                        <span class="fname">{{ imageName || ('upload_current_photo' | translate) }}</span>
                        <button type="button" class="link-btn danger" (click)="clearImage(); $event.stopPropagation()">
                            {{ 'equipment_modal_remove' | translate }}
                        </button>
                    </div>
                } @else {
                    <p class="dropzone__hint">
                        <strong>{{ 'upload_drop_title' | translate }}</strong> {{ 'upload_drop_rest' | translate }}<br />
                        {{ 'upload_drop_formats' | translate }}
                    </p>
                }
            </div>
            <input #fileInput type="file" class="file-input" accept="image/png,image/jpeg,image/webp,image/gif"
                (change)="onFilePicked($event)" />
            @if (imageError) {
                <p class="err">{{ imageError }}</p>
            }
        </div>

        <div class="specs">
            <div class="specs__head">
                <span>{{ 'equipment_field_specs' | translate }}</span>
                <button type="button" class="link-btn" (click)="addSpec()">{{ 'equipment_modal_add_row' | translate }}</button>
            </div>

            @if (specifications.length === 0) {
                <p class="hint">{{ 'equipment_modal_no_specs' | translate }}</p>
            } @else {
                @for (spec of specifications; track $index) {
                    <div class="spec-row">
                        <input type="text" [(ngModel)]="spec.label" [name]="'spec-label-' + $index"
                            [placeholder]="'equipment_modal_spec_label_placeholder' | translate" autocomplete="off" />
                        <input type="text" [(ngModel)]="spec.value" [name]="'spec-value-' + $index"
                            [placeholder]="'equipment_modal_spec_value_placeholder' | translate" autocomplete="off" />
                        <button type="button" class="icon-btn danger" (click)="removeSpec($index)"
                            [attr.aria-label]="'equipment_modal_remove_row' | translate">&times;</button>
                    </div>
                }
            }
        </div>

        <button type="submit" class="eq-modal__submit">{{ (isEdit ? 'admin_action_save_changes' : 'admin_action_create') | translate }}</button>
    </form>
</div>
